import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FolioBookingsService {
  busSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetFolioBookings(
    loyaltynum: string | undefined,
    lastname: string | undefined
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const FolioBookings: JSON = <JSON>(<unknown>{
      CustomerID: loyaltynum,
      LastName: lastname,
      BookingStatus: ['I', 'O'],
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetFolioBookings',
      JSON.stringify(FolioBookings),
      {
        headers: headers,
      }
    );
  }
}
